import { hasMany, Model } from 'miragejs';

export default Model.extend({
  steps: hasMany('approval-workflow-state-step'),
});
